import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { classNames } from "@/utils/utils";
import { Button } from "@/components/common/Button";
import { CloseIcon } from "@/components/common/icons/CloseIcon";

import styles from "./Modal.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  withX?: boolean;
  className?: string;
  xClassName?: string;
  children?: React.ReactNode;
};

export const Modal: React.FC<Props> = ({
  isOpen,
  onClose,
  children,
  withX,
  className,
  xClassName,
}) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (!isOpen) {
      return;
    }
    gsap.to(ref.current, {
      background: `rgba(0, 0, 0, 0.25)`,
      duration: 1,
      ease: "power2",
    });
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div ref={ref} className={styles.blackOverlay}>
      <div className={classNames(styles.popup, className)}>
        {children}
        {withX && (
          <Button
            variant="clean"
            className={classNames(styles.close, xClassName)}
            onClick={onClose}
          >
            <CloseIcon />
          </Button>
        )}
      </div>
    </div>
  );
};
